import { CircleDotDashed, CircleCheck, Activity, CircleX } from "lucide-react";
const RenderRecentDealStatus = ({status})=>{
  if(status.toLowerCase() === "pending"){
    return (
      <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[14px] font-medium bg-yellow-50 text-yellow-700 ring-1 ring-yellow-600/20">
        <CircleDotDashed className="w-3.5 h-3.5" />
        {"Pending"}
      </div>
    );
  }
  else if(status.toLowerCase() === "approved"){
    return (

      <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[14px] font-medium bg-green-50 text-green-700 ring-1 ring-green-600/20">
        <CircleCheck className="w-3.5 h-3.5" />
        {"Approved"}
      </div>
    )
  }
  else if(status.toLowerCase() === "inactive"){
    return(
      <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[14px] font-medium bg-gray-50 text-gray-700 ring-1 ring-gray-600/20">
        <CircleX className="w-3.5 h-3.5" />
        {"Inactive"}
      </div>
    )
  }
  else if(status.toLowerCase() === "active"){
    return(

      <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[14px] font-medium bg-purple-50 text-purple-700 ring-1 ring-purple-600/20">
        <Activity className="w-3.5 h-3.5" />
        {"Live"}
      </div>
    )
  }
  else{
    return(

      <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[14px] font-medium bg-red-50 text-red-700 ring-1 ring-red-600/20">
        <CircleX className="w-3.5 h-3.5" />
        {"Rejected"}
      </div>
    )
  }
}

export default RenderRecentDealStatus;